import CobrowseIO from "cobrowse-sdk-js"

export interface CobrowseUserData {
  extCrmId: string
}

export interface CobrowseOptions {
  license: string
  user?: CobrowseUserData
}

export async function initCobrowse(options: CobrowseOptions): Promise<void> {
  if (typeof window === "undefined") return

  CobrowseIO.license = options.license

  if (options.user) {
    CobrowseIO.customData = { ext_crm_id: options.user.extCrmId }
  } else {
    CobrowseIO.registration = false
  }

  CobrowseIO.redactedViews = [".cobrowse-redact"]

  try {
    await CobrowseIO.client()
    await CobrowseIO.start()
  } catch (error) {
    console.error("Cobrowse initialization failed:", error)
  }
}

export async function generateSessionCode(): Promise<string> {
  // client() is the SDK's idiomatic "wait until connected" call and is safe to
  // call multiple times. It guards against a race where the user requests a
  // session code before initCobrowse() has finished connecting.
  await CobrowseIO.client()
  return CobrowseIO.createSessionCode()
}
